import React, { Component } from 'react'
import ModalBuscaPersona from './modals/buscaPersona';
import ModalAgregaPersona from './modals/agregaPersona';
import Form from 'react-bootstrap/Form';
import { PageTitle } from '../../../../_metronic/layout/core';
import AlertComponent from '../../../Components/Alerts';
import FormGroup from 'react-bootstrap/FormGroup';
import Spinner from 'react-bootstrap/Spinner';
import SpinnerButton from '../../../Components/SpinnerButton';
import SearchableDropdown from '../../../Components/SearchDropdown';

const API_URL = process.env.REACT_APP_API_URL

const personaInitState = {
    alias: '',
    nombre: '',
    primerApellido: '',
    segundoApellido: '',
    sexo: '',
    orientacionSexual: '',
    identidadGenero: '',
    fechaNacimiento: '',
    curp: '',
    renavi: '',
    estadoCivil: '',
    _id: ''
}

const entrevistaInitState = {
    _id: "",
    clasificacion: "",
    infoAdicional: "",
    tipoMaterialAdicional: "",
    materialAdicional: "",
    sesiones: "",
    duracion: "",
    tipoEntrevista: "",
    tipoTestimoniante: "",
    transcriptor: "",
    entrevistador: "",
    emi: "",
    colectivo: "",
    grupoMilitancia: "",
    tlaxcoaque: "",
    lugar: "",
    entidad: "",
    fecha: "",
    persona: { _id: "", nombre: "" },
    personaNew: { _id: "", nombre: "", primerApellido: "", segundoApellido: "" },
}

export default class EntrevistaIndividual extends Component {

    constructor(props) {
        super(props);
        this.state = {
            alertMessage: '',
            alertState: false,
            data: entrevistaInitState,
            persona: personaInitState,
            condiciones: [],
            personaEntrevistada: personaInitState,
            buttonsDisabled: true,
            orgPertenecio: [],
            orgPertenece: [],
            fzaPertenecio: [],
            fzaPertenece: [],
            gravesViolaciones: [],
            subcontextos: [],
            entrevista: [],
            estados: [],
            municipios: [],
            localidades: [],
            estado: 0,
            isLoadingMun: false,
            isLoadingLoc: false,
        }
        this.seleccionaPersona = this.seleccionaPersona.bind(this);
        this.setCondiciones = this.setCondiciones.bind(this);
        this.saveCondiciones = this.saveCondiciones.bind(this);
        this.CloseAlert = this.CloseAlert.bind(this);
        this.setOrgPertenece = this.setOrgPertenece.bind(this);
        this.setOrgPertenecio = this.setOrgPertenecio.bind(this);
        this.setFzaPertenece = this.setFzaPertenece.bind(this);
        this.setFzaPertenecio = this.setFzaPertenecio.bind(this);
        this.saveOrganizaciones = this.saveOrganizaciones.bind(this);
    }

    async onChange(e) {
        const oldData = [...this.state.entrevista];
        const newData = oldData.filter(item => item.key !== e.target.id);
        newData.push({ key: e.target.id, value: e.target.value });
        await this.setState({ entrevista: newData });
        console.log(this.state.entrevista)
    }

    async CloseAlert() {
        this.setState({ alertState: false });
    }

    async componentDidMount() {
        try {
            const response = await fetch(`${API_URL}/gravesViolaciones/getAll`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            const listaGravesViolaciones = data.map(item => {
                item.added = false
                return item;
            }
            );
            await this.setState({ gravesViolaciones: listaGravesViolaciones });
        } catch (err) {
            console.log(err.message);
        };
        try {
            const response = await fetch(`${API_URL}/subcontexto/getAll`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            const subcontextoList = data.map(item => {
                item.added = false
                return item;
            }
            );
            await this.setState({ subcontextos: subcontextoList });
        } catch (err) {
            console.log(err.message);
        };

        try {
            const response = await fetch(`${API_URL}/lugar/getEstados`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            const estadosList = data.map(item => {
                item.added = false
                return item;
            }
            );
            await this.setState({ estados: estadosList });
        } catch (err) {
            console.log(err.message);
        };
    }

    async setCondiciones(condis) {
        await this.setState({ condiciones: condis });
    }

    setOrgPertenece(orgs) {
        this.setState({ orgPertenece: orgs });
    }

    setOrgPertenecio(orgs) {
        this.setState({ orgPertenecio: orgs });
    }

    setFzaPertenece(orgs) {
        this.setState({ fzaPertenece: orgs });
    }

    async getMunicipios(e) {
        this.setState({ isLoadingMun: true })
        try {
            const response = await fetch(`${API_URL}/lugar/getMunicipios/${e.target.value}`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            const list = data.map(item => {
                item.added = false
                return item;
            }
            );
            await this.setState({ municipios: list, estado: e.target.value });
            this.setState({ isLoadingMun: false })
        } catch (err) {
            console.log(err)
        }
    }

    async getLocalidades(e) {
        this.setState({ isLoadingLoc: true })
        try {
            const response = await fetch(`${API_URL}/lugar/getLocalidades/${e.target.value}/${this.state.estado}`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            const list = data.map(item => {
                item.added = false
                return item;
            }
            );
            await this.setState({ localidades: list });
            this.setState({ isLoadingLoc: false })
        } catch (err) {
            console.log(err)
        }
    }

    async setFzaPertenecio(orgs) {
        this.setState({ fzaPertenecio: orgs });
    }

    async saveOrganizaciones() {

        const newOrgPertenece = [];
        this.state.orgPertenece.forEach(element => {
            if (element.added)
                newOrgPertenece.push({ _id: element._id });
        });

        const newOrgPertenecio = [];
        this.state.orgPertenecio.forEach(element => {
            if (element.added)
                newOrgPertenecio.push({ _id: element._id });
        });
        /*
                const newFzaPertenecio = [];
                this.state.fzaPertenecio.forEach(element => {
                    if (element.added)
                        newFzaPertenecio.push({ _id: element._id });
                });
        
                const newFzaPertenece = [];
                this.state.fzaPertenece.forEach(element => {
                    if (element.added)
                        newFzaPertenece.push({ _id: element._id });
                });
        */
        const formSerialized = { orgPertenece: newOrgPertenece, orgPertenecio: newOrgPertenecio, id: this.state.personaEntrevistada._id }

        try {
            const response = await fetch(`${API_URL}/persona/addOrganizaciones`, { //Aquí las organizacionPertenece = Pertenencia o Colectivo, organizacionPertenecio = Grupo de Militancia
                method: 'POST',
                body: JSON.stringify(formSerialized),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const jsonResponse = await response.json();
            if (response.status >= 200 && response.status < 300) {
                this.setState({ alertState: true, alertMessage: 'Se guardó la información de la filiación correctamente' })
            }
            else {
                console.log(jsonResponse);
            }
        } catch (err) {
            console.log("se murio");
        }
    }

    async saveCondiciones() {
        const newCondis = [];
        this.state.condiciones.forEach(element => {
            if (element.checked)
                newCondis.push({ _id: element._id });
        });
        const formSerialized = { condiciones: newCondis, id: this.state.personaEntrevistada._id }
        try {
            const response = await fetch(`${API_URL}/persona/addCondiciones`, {
                method: 'POST',
                body: JSON.stringify(formSerialized),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const jsonResponse = await response.json();
            if (response.status >= 200 && response.status < 300) {
                this.setState({ alertState: true, alertMessage: 'Se guardaron correctamente las condiciones diferenciadoras' })
            }
            else {
                console.log(jsonResponse);
            }
        } catch (err) {
            console.log("se murio");
        }
    }

    async seleccionaPersona(persona) {
        var moment = require('moment');

        persona.fechaNacimiento = moment(persona.fechaNacimiento).format('YYYY-MM-DD')
        let newData = [];

        let entrevistaPersona = [...this.state.entrevista];
        entrevistaPersona = entrevistaPersona.filter(item => item.key !== "_id")
        entrevistaPersona = entrevistaPersona.filter(item => item.key !== "nombre")
        entrevistaPersona = entrevistaPersona.filter(item => item.key !== "primerApellido")
        entrevistaPersona = entrevistaPersona.filter(item => item.key !== "segundoApellido")
        entrevistaPersona.push({ key: "_id", value: persona._id })
        entrevistaPersona.push({ key: "nombre", value: persona.nombre })
        entrevistaPersona.push({ key: "primerApellido", value: persona.primerApellido })
        entrevistaPersona.push({ key: "segundoApellido", value: persona.segundoApellido })

        try {
            const response = await fetch(`${API_URL}/condicionDif/getAll`);
            if (!response.ok) {
                throw Error(response.statusText);
            }

            const condicionesRes = await response.json();

            newData = condicionesRes.map(condi => {
                if (persona.condicionesDiferenciadoras.find(cond => cond._id === condi._id)) {
                    condi.checked = true;
                }
                else {
                    condi.checked = false;
                }
                return condi;
            }
            );
        } catch (err) {
            console.log(err.message);
        };

        try {
            const response = await fetch(`${API_URL}/colectivo/getAll`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const organizaciones = await response.json();

            const listaOrganizaciones = organizaciones.map(item => {
                if (persona.orgPertenece.find(aux => aux._id === item._id)) {
                    item.added = true;
                }
                else {
                    item.added = false;
                }
                return item;
            }
            );
            this.setOrgPertenece(listaOrganizaciones);
        } catch (err) {
            console.log(err.message);
        };

        try {
            const response = await fetch(`${API_URL}/organizacion/getAll`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const organizaciones = await response.json();
            const listaOrganizaciones = organizaciones.map(item => {
                if (persona.orgPertenecio.find(aux => aux._id === item._id)) {
                    item.added = true;
                }
                else {
                    item.added = false;
                }
                return item;
            }
            );
            this.setOrgPertenecio(listaOrganizaciones);
        } catch (err) {
            console.log(err.message);
        };

        try {
            const response = await fetch(`${API_URL}/organizacion/getAll`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const organizaciones = await response.json();
            const listaOrganizaciones = organizaciones.map(item => {
                if (persona.fzaPertenecio.find(aux => aux._id === item._id)) {
                    item.added = true;
                }
                else {
                    item.added = false;
                }
                return item;
            }
            );
            this.setFzaPertenecio(listaOrganizaciones);
        } catch (err) {
            console.log(err.message);
        };

        try {
            const response = await fetch(`${API_URL}/organizacion/getAll`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const organizaciones = await response.json();
            const listaOrganizaciones = organizaciones.map(item => {
                if (persona.fzaPertenece.find(aux => aux._id === item._id)) {
                    item.added = true;
                }
                else {
                    item.added = false;
                }
                return item;
            }
            );
            this.setFzaPertenece(listaOrganizaciones);
        } catch (err) {
            console.log(err.message);
        };
        console.log(entrevistaPersona)
        await this.setState({ personaEntrevistada: persona, buttonsDisabled: false, condiciones: newData, entrevista: entrevistaPersona });
        console.log(this.state.entrevista)
    }

    render() {
        return (
            <>
                <AlertComponent stat={this.state.alertState} title="Guardado" closeAlert={this.CloseAlert}>{this.state.alertMessage}</AlertComponent>
                <PageTitle breadcrumbs={[]}>Nueva Entrevista</PageTitle>
                <ModalBuscaPersona titulo="Busrcar Persona" seleccionaPersona={this.seleccionaPersona}>Buscar Persona</ModalBuscaPersona>{/* {' '}
                <ModalAgregaPersona titulo="Agrega persona no registrada">Agregar Persona</ModalAgregaPersona> */}
                <div className="separator border-dark my-5"></div>
                <div className="card card-border">
                    <div className="card-header">
                        <h4 className='mt-7'>Ficha de entrevista</h4>
                    </div>
                    <Form className='form'>
                        <Form.Group controlId="personaId">
                            <Form.Control type="hidden" defaultValue={this.state.personaEntrevistada._id} />
                        </Form.Group>
                        <div className='card-body border-top p-9'>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Clasificación</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="clasificacion">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Clasificación" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Fecha</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="fecha">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="date" placeholder="Fecha" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Entidad</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="entidad">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Entidad" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Lugar</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-4 fv-row'>
                                            <FormGroup controlId="estado">
                                                <Form.Select onChange={(e) => { this.getMunicipios(e) }}>
                                                    <option>Seleccionar...</option>
                                                    {this.state.estados.map(estado =>
                                                        <option value={estado.cve} key={estado._id}>{estado.nombre}</option>
                                                    )}
                                                </Form.Select>
                                            </FormGroup>
                                        </div>
                                        <div className='col-lg-4 fv-row'>
                                            <FormGroup>
                                                {this.state.isLoadingMun ? (
                                                    <Spinner animation="border" role="status">
                                                        <span className="visually-hidden">Cargando...</span>
                                                    </Spinner>
                                                ) : (
                                                    <Form.Select onChange={(e) => { this.getLocalidades(e) }}>
                                                        <option>Seleccionar...</option>
                                                        {this.state.municipios.map(municipio =>
                                                            <option value={municipio.cve} key={municipio._id}>{municipio.nombre}</option>
                                                        )}
                                                    </Form.Select>
                                                )}
                                            </FormGroup>
                                        </div>
                                        <div className='col-lg-4 fv-row'>
                                            <FormGroup controlId="localidad">
                                                {this.state.isLoadingLoc ? (
                                                    <Spinner animation="border" role="status">
                                                        <span className="visually-hidden">Cargando...</span>
                                                    </Spinner>
                                                ) : (
                                                    <Form.Select onChange={(e) => { this.setLocalidad(e) }}>
                                                        <option>Seleccionar...</option>
                                                        {this.state.localidades.map(localidad =>
                                                            <option value={localidad._id} key={localidad._id}>{localidad.nombre}</option>
                                                        )}
                                                    </Form.Select>
                                                )}
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Proyecto Tlaxcoaque</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="tlaxcoaque">
                                                <Form.Select>
                                                    <option value="No">No</option>
                                                    <option value="Si">Si</option>
                                                </Form.Select>
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Nombre completo</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-4 fv-row'>
                                            <FormGroup controlId="nombre">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Nombre" defaultValue={this.state.personaEntrevistada.nombre} />
                                            </FormGroup>
                                        </div>
                                        <div className='col-lg-4 fv-row'>
                                            <FormGroup controlId="primerApellido">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Primer Apellido" defaultValue={this.state.personaEntrevistada.primerApellido} />
                                            </FormGroup>
                                        </div>
                                        <div className='col-lg-4 fv-row'>
                                            <FormGroup controlId="segundoApellido">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Segundo Apellido" defaultValue={this.state.personaEntrevistada.segundoApellido} />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Grupo de Militancia</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="grupoMilitancia">
                                                <SearchableDropdown apiUrl={`${API_URL}/organizacion/getAll`} elementName='grupoMilitancia' onClick={this.manejaOrganizaciones} />                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Pertenecía a Colectivo</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="colectivo">
                                                <SearchableDropdown apiUrl={`${API_URL}/organizacion/getAll`} elementName='perteneciaColectivo' onClick={this.manejaOrganizaciones} />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>EMI responsable del testimonio</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="emi">
                                                <Form.Select>
                                                    <option>Seleccionar EMI</option>
                                                    <option value="EMI1">EMI1</option>
                                                    <option value="EMI2">EMI2</option>
                                                    <option value="EMI3">EMI3</option>
                                                    <option value="EMI5">EMI5</option>
                                                    <option value="Audiencias">Audiencias</option>
                                                </Form.Select>
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Entrevistador.a (E) / Asistente (A)</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="entrevistador">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Entrevistador/Asistente" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Transcriptor</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="transcriptor">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Transcriptor" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Tipo de Testimoniante</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="tipoTestimoniante">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Tipo Testimoniante" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Tipo de Entrevista</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="tipoEntrevista">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Tipo Entrevista" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Duración</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="duracion">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Duracion" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Sesiones</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="sesiones">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Sesiones" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Se recibió material adicional</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="materialAdicional">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Material Adicional" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Tipo de material recibido</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="tipoMaterial">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Tipo Material" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Información Adicional</label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className='col-lg-12 fv-row'>
                                            <FormGroup controlId="infoAdicional">
                                                <Form.Control onChange={(e) => { this.onChange(e) }} className='form-control form-control-lg form-control-solid mb-3 mb-lg-0' type="text" placeholder="Información Adicional" />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='card-footer d-flex justify-content-end py-6 px-9'>
                            <SpinnerButton onClick={() => alert("Guardando")}>Guardar</SpinnerButton>
                        </div>
                    </Form>
                </div>            </>
        )
    }
}
